"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _dompurify = _interopRequireDefault(require("dompurify"));
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
var _core = require("core.ui-module_site-components");
var _ParticipantIdentificationHelpStepResponse = _interopRequireDefault(require("../../api/auth/ParticipantIdentificationHelpStepResponse"));
var _ApplicationContext = require("../../api/ApplicationContext");
var _ReturnToLoginLink = _interopRequireDefault(require("./ReturnToLoginLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const decorateErrorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger has-text-left"
}, msg);
const recaptchaRef = /*#__PURE__*/_react.default.createRef();
class ParticipantIdentificationHelpStep extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onReCaptchaChange", () => {
      const recaptchaValue = recaptchaRef.current.getValue();
      this.setState({
        recaptchaValue,
        recaptchaError: null
      });
    });
    this.state = {
      isLoading: false,
      lastFourSsn: '',
      confirmLastFourSsn: '',
      dob: '',
      zip: '',
      internationalZip: false,
      helpType: '',
      errorMessage: '',
      forgotOptionError: '',
      lastFourSsnErrorMessage: '',
      confirmLastFourSsnErrorMessage: '',
      dobErrorMessage: '',
      zipErrorMessage: '',
      recaptchaValue: '',
      recaptchaError: null
    };
    this.returnToLogin = this.returnToLogin.bind(this);
  }
  validateLength(field, maxLength) {
    if (maxLength) {
      return field && field.length > 0 && field.length <= maxLength;
    }
    return field && field.length > 0;
  }
  validateNumbers(field) {
    return field && !Number.isNaN(field);
  }
  validateDobFormat(dobText) {
    if (dobText) {
      const dobMatches = dobText.match(/^(\d{4})[-](\d{1,2})[-](\d{1,2})$/);
      return dobMatches !== null;
    }
    return false;
  }
  validateDobDate(dobText) {
    if (dobText) {
      const dobMatches = dobText.match(/^(\d{4})[-](\d{1,2})[-](\d{1,2})$/);
      const dobDate = new Date(dobMatches[1], dobMatches[2] - 1, dobMatches[3]);
      const nowDate = new Date();
      return dobDate < nowDate;
    }
    return false;
  }
  submit(e) {
    e.preventDefault();
    const {
      lastFourSsn,
      confirmLastFourSsn,
      zip,
      dob,
      helpType,
      recaptchaValue,
      internationalZip
    } = this.state;
    if (!this.validateLength(lastFourSsn, 4)) {
      this.setState({
        lastFourSsn,
        lastFourSsnErrorMessage: 'Please enter the last four digits of your SSN'
      });
      return;
    }
    if (!this.validateNumbers(lastFourSsn)) {
      this.setState({
        lastFourSsn,
        lastFourSsnErrorMessage: 'Please enter numbers for the last four digits of your SSN'
      });
      return;
    }
    if (!this.validateLength(confirmLastFourSsn, 4)) {
      this.setState({
        confirmLastFourSsn,
        confirmLastFourSsnErrorMessage: 'Please enter the last four digits of your SSN'
      });
      return;
    }
    if (!this.validateNumbers(confirmLastFourSsn)) {
      this.setState({
        confirmLastFourSsn,
        confirmLastFourSsnErrorMessage: 'Please enter numbers for the last four digits of your SSN'
      });
      return;
    }
    if (!internationalZip && !this.validateLength(zip, 5)) {
      this.setState({
        zip,
        zipErrorMessage: 'Please enter your five digit zipcode'
      });
      return;
    }
    if (!internationalZip && !this.validateNumbers(zip)) {
      this.setState({
        zip,
        zipErrorMessage: 'Please enter a valid five digit zipcode'
      });
      return;
    }
    if (!this.validateLength(dob, 10)) {
      this.setState({
        dob,
        dobErrorMessage: 'Please enter a complete DOB in the format of MM/DD/YYYY'
      });
      return;
    }
    if (!this.validateDobFormat(dob)) {
      this.setState({
        dob,
        dobErrorMessage: 'Please enter a valid DOB in the format of MM/DD/YYYY'
      });
      return;
    }
    if (!this.validateDobDate(dob)) {
      this.setState({
        dob,
        dobErrorMessage: 'Please enter a valid DOB in the format of MM/DD/YYYY'
      });
      return;
    }
    if (_ApplicationContext.ApplicationContext.getRecaptchaSiteKey() && !recaptchaValue) {
      this.setState({
        recaptchaError: 'Please complete recaptcha'
      });
      return;
    }
    this.setState({
      errorMessage: '',
      lastFourSsnErrorMessage: '',
      confirmLastFourSsnErrorMessage: '',
      zipCodeErrorMessage: '',
      dobErrorMessage: '',
      forgotOptionError: '',
      recaptchaError: '',
      isLoading: true
    });
    const step = new _ParticipantIdentificationHelpStepResponse.default();
    step.lastFourSsn = lastFourSsn;
    step.confirmLastFourSsn = confirmLastFourSsn;
    step.dob = dob;
    step.zip = zip;
    step.recaptchaResponse = recaptchaValue;
    step.helpType = helpType;
    this.props.listener(this, step);
  }
  changeLastFourSsn(e) {
    const lastFourSsn = e.target.value;
    if (!this.validateLength(lastFourSsn)) {
      this.setState({
        lastFourSsn,
        lastFourSsnErrorMessage: 'This field is required for submission'
      });
    } else {
      this.setState({
        lastFourSsn,
        lastFourSsnErrorMessage: null
      });
    }
  }
  changeConfirmLastFourSsn(e) {
    const confirmLastFourSsn = e.target.value;
    if (!this.validateLength(confirmLastFourSsn)) {
      this.setState({
        confirmLastFourSsn,
        confirmLastFourSsnErrorMessage: 'This field is required for submission'
      });
    } else {
      this.setState({
        confirmLastFourSsn,
        confirmLastFourSsnErrorMessage: null
      });
    }
  }
  changeZip(e) {
    const zip = e.target.value;
    if (!this.validateLength(zip)) {
      this.setState({
        zip,
        zipErrorMessage: 'This field is required for submission'
      });
    } else {
      this.setState({
        zip,
        zipErrorMessage: null
      });
    }
  }
  changeInternationalZip(e) {
    if (e.target.checked) {
      this.setState({
        internationalZip: true,
        zipErrorMessage: null,
        zip: ''
      });
    } else {
      this.setState({
        internationalZip: false
      });
    }
  }
  changeDob(e) {
    const dob = e.target.value;
    if (!this.validateLength(dob)) {
      this.setState({
        dob,
        dobErrorMessage: 'This field is required for submission'
      });
    } else {
      this.setState({
        dob,
        dobErrorMessage: null
      });
    }
  }
  changeHelpType(e) {
    const helpType = e.target.value;
    if (!this.validateHelpType(helpType)) {
      this.setState({
        helpType,
        helpTypeError: 'This field is required for submission'
      });
    } else {
      this.setState({
        helpType,
        helpTypeError: null
      });
    }
  }
  validate(lastFourSsn, confirmLastFourSsn, zip, internationalZip, dob, helpType) {
    const isValid = this.validateLength(lastFourSsn) && this.validateLength(confirmLastFourSsn) && (!internationalZip && this.validateLength(zip) || internationalZip) && this.validateLength(dob) && this.validateHelpType(helpType);
    return isValid;
  }
  validateHelpType(helpType) {
    return helpType === 'U' || helpType === 'P' || helpType === 'R';
  }
  validateRecaptcha(recaptchaValue) {
    return !_ApplicationContext.ApplicationContext.getRecaptchaSiteKey() || recaptchaValue && recaptchaValue.length > 0;
  }
  returnToLogin(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    this.props.history.push(_ApplicationContext.ApplicationContext.getLoginPath());
  }
  render() {
    const {
      site
    } = this.props;
    const {
      lastFourSsn,
      confirmLastFourSsn,
      zip,
      internationalZip,
      dob,
      helpType,
      rawErrorMessage,
      lastFourSsnErrorMessage,
      confirmLastFourSsnErrorMessage,
      dobErrorMessage,
      zipErrorMessage,
      helpTypeError,
      isLoading,
      recaptchaValue,
      recaptchaError
    } = this.state;

    // Dynamic message that says where otp was sent

    const disabled = !this.validate(lastFourSsn, confirmLastFourSsn, zip, internationalZip, dob, helpType) || rawErrorMessage || !this.validateRecaptcha(recaptchaValue);
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement("form", {
      id: "authForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "px-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title",
      dangerouslySetInnerHTML: {
        __html: site.forgotLoginTitle && site.forgotLoginTitle.length > 0 ? _dompurify.default.sanitize(site.forgotLoginTitle) : 'Forgot Login'
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle has-text-left pb-4"
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "lastFourSsn",
      className: "label has-text-left pb-2"
    }, "Last Four SSN", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${rawErrorMessage && 'is-danger'}`,
      type: "password",
      placeholder: "Enter the last four digits of your SSN",
      id: "lastFourSsn",
      name: "lastFourSsn",
      size: "4",
      onChange: e => this.changeLastFourSsn(e),
      onBlur: e => this.changeLastFourSsn(e),
      value: lastFourSsn,
      autoComplete: "one-time-code",
      inputMode: "numeric",
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons is-size-3"
    }, "lock"))))), decorateErrorMessage(rawErrorMessage), decorateErrorMessage(lastFourSsnErrorMessage), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "confirmLastFourSsn",
      className: "label has-text-left pb-2"
    }, "Confirm Last Four SSN", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${rawErrorMessage && 'is-danger'}`,
      type: "password",
      placeholder: "Re-enter the last four digits of your SSN",
      id: "confirmLastFourSsn",
      name: "confirmLastFourSsn",
      size: "4",
      onChange: e => this.changeConfirmLastFourSsn(e),
      onBlur: e => this.changeConfirmLastFourSsn(e),
      value: confirmLastFourSsn,
      autoComplete: "one-time-code",
      inputMode: "numeric",
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons is-size-3"
    }, "lock"))))), decorateErrorMessage(confirmLastFourSsnErrorMessage), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "zip",
      className: "label has-text-left"
    }, "ZIP Code", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${rawErrorMessage && 'is-danger'}`,
      type: "number",
      placeholder: "Enter your five digit ZIP Code",
      id: "zip",
      name: "zip",
      size: "5",
      onChange: e => this.changeZip(e),
      onBlur: e => this.changeZip(e),
      value: zip,
      autoComplete: "postal-code",
      inputMode: "numeric",
      required: true,
      disabled: internationalZip
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons is-size-3"
    }, "location_city"))))), decorateErrorMessage(zipErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field pb-2"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: " has-text-left"
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: "checkbox",
      htmlFor: "internationalZip"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `checkbox ${rawErrorMessage && 'is-danger'}`,
      type: "checkbox",
      id: "internationalZip",
      name: "internationalZip",
      onChange: e => this.changeInternationalZip(e),
      value: "Y",
      autoComplete: "off"
      // checked={internationalZip}
      ,
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", null, "I have a non-US address")))), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "title",
      className: "label has-text-left"
    }, "Date of Birth", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input is-fullwidth ${rawErrorMessage && 'is-danger'}`,
      type: "date",
      placeholder: "Enter your Date of Birth (MM/DD/YYYY)",
      id: "dob",
      name: "dob",
      size: "5",
      onChange: e => this.changeDob(e),
      onBlur: e => this.changeDob(e),
      value: dob,
      autoComplete: "bday",
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons is-size-3"
    }, "calendar_month"))))), decorateErrorMessage(dobErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-text-left pl-2"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "helpTypeRetrieveUserId",
      className: "label is-size-4"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `radio ${helpTypeError && 'is-danger'}`,
      type: "radio",
      id: "helpTypeRetrieveUserId",
      name: "helpType",
      onChange: e => this.changeHelpType(e),
      onBlur: e => this.changeHelpType(e),
      value: "R",
      required: true
    }), ' ', site.forgotLoginRetrieveUserIdLabel && site.forgotLoginRetrieveUserIdLabel.length > 0 ? site.forgotLoginRetrieveUserIdLabel : 'Retrieve User ID')), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-text-left pl-2"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "helpTypeResetUserId",
      className: "label is-size-4"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `radio ${helpTypeError && 'is-danger'}`,
      type: "radio",
      id: "helpTypeResetUserId",
      name: "helpType",
      onChange: e => this.changeHelpType(e),
      onBlur: e => this.changeHelpType(e),
      value: "U",
      required: true
    }), ' ', site.forgotLoginResetUserIdLabel && site.forgotLoginResetUserIdLabel.length > 0 ? site.forgotLoginResetUserIdLabel : 'Reset User ID')), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-text-left pl-2"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "helpTypeResetPassword",
      className: "label is-size-4"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `radio ${helpTypeError && 'is-danger'}`,
      type: "radio",
      id: "helpTypeResetPassword",
      name: "helpType",
      onChange: e => this.changeHelpType(e),
      onBlur: e => this.changeHelpType(e),
      value: "P",
      required: true
    }), ' ', site.forgotLoginResetPasswordLabel && site.forgotLoginResetPasswordLabel.length > 0 ? site.forgotLoginResetPasswordLabel : 'Reset Password')), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-text-left pl-2"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "helpTypeResetUserIdPassword",
      className: "label is-size-4"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `radio ${helpTypeError && 'is-danger'}`,
      type: "radio",
      id: "helpTypeResetUserIdPassword",
      name: "helpType",
      onChange: e => this.changeHelpType(e),
      onBlur: e => this.changeHelpType(e),
      value: "B",
      required: true
    }), ' ', site.forgotLoginResetUserIdPasswordLabel && site.forgotLoginResetUserIdPasswordLabel.length > 0 ? site.forgotLoginResetUserIdPasswordLabel : 'Reset User ID & Password')), decorateErrorMessage(helpTypeError)), _ApplicationContext.ApplicationContext.getRecaptchaSiteKey() && /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
      ref: recaptchaRef,
      sitekey: _ApplicationContext.ApplicationContext.getRecaptchaSiteKey(),
      onChange: this.onReCaptchaChange
    }), decorateErrorMessage(recaptchaError))), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary is-fullwidth",
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Next"))), /*#__PURE__*/_react.default.createElement(_ReturnToLoginLink.default, {
      returnToLogin: this.returnToLogin
    })))));
  }
}
ParticipantIdentificationHelpStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  site: _propTypes.default.shape({
    forgotLoginRetrieveUserIdLabel: _propTypes.default.string,
    forgotLoginResetPasswordLabel: _propTypes.default.string,
    forgotLoginResetUserIdPasswordLabel: _propTypes.default.string,
    forgotLoginResetUserIdLabel: _propTypes.default.string,
    forgotLoginTitle: _propTypes.default.string
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(ParticipantIdentificationHelpStep);
//# sourceMappingURL=ParticipantIndentificationHelpStep.js.map